// LOGO
// FAVICON
// APP ICONS
import _APP_STORE_SMALL_ICON from '../../public/images/icons/app-store-small.svg'
import _APP_STORE_ICON from '../../public/images/icons/app-store.svg'
// USER MENU ICONS
// SHARING ICONS
// GENERIC ICONS
import _ARROW_DOWN_ICON from '../../public/images/icons/arrow-down.svg'
import _ARROW_LEFT_ICON from '../../public/images/icons/arrow-left.svg'
import _ARROW_RIGHT_WHITE_ICON from '../../public/images/icons/arrow-right-white.svg'
import _ARROW_RIGHT_ICON from '../../public/images/icons/arrow-right.svg'
import _ARROW_UP_RIGHT_ICON from '../../public/images/icons/arrow-up-right.svg'
import _ARROW_UP_ICON from '../../public/images/icons/arrow-up.svg'
import _CALENDAR_ICON from '../../public/images/icons/calendar.svg'
import _CHECK_WHITE_ICON from '../../public/images/icons/check-white.svg'
import _CHECK_ICON from '../../public/images/icons/check.svg'
import _CHEVRON_RIGHT_ICON from '../../public/images/icons/chevron-right.svg'
import _CLOCK_WHITE_ICON from '../../public/images/icons/clock-white.svg'
import _CLOCK_ICON from '../../public/images/icons/clock.svg'
import _CLOSE_ICON from '../../public/images/icons/close.svg'
import _COPY_ICON from '../../public/images/icons/copy.svg'
import _DOT_ICON from '../../public/images/icons/dot.svg'
import _EMAIL_ICON from '../../public/images/icons/email.svg'
import _FAVICON from '../../public/images/icons/favicon.ico'
import _INFO_ICON from '../../public/images/icons/info.svg'
import _INTERNATIONAL_ICON from '../../public/images/icons/international.svg'
import _KEY_ICON from '../../public/images/icons/key.svg'
import _LEVEL_ICON from '../../public/images/icons/level.svg'
import _LINK_ICON from '../../public/images/icons/link.svg'
import _LOCATION_ICON from '../../public/images/icons/location.svg'
import _LOG_OUT_ICON from '../../public/images/icons/log-out.svg'
import _EVERSPORTS_LOGO from '../../public/images/icons/logo.svg'
import _MENU_ICON from '../../public/images/icons/menu.svg'
import _MESSAGE_ICON from '../../public/images/icons/messages.svg'
import _MY_BOOKINGS_ICON from '../../public/images/icons/my-bookings.svg'
import _MY_DETAILS_ICON from '../../public/images/icons/my-details.svg'
import _MY_PRODUCTS_ICON from '../../public/images/icons/my-products.svg'
import _MY_VIDEOS_ICON from '../../public/images/icons/my-videos.svg'
import _PEOPLE_ICON from '../../public/images/icons/people.svg'
import _PLAY_STORE_SMALL_ICON from '../../public/images/icons/play-store-small.svg'
import _PLAY_STORE_ICON from '../../public/images/icons/play-store.svg'
import _ROOM_ICON from '../../public/images/icons/room.svg'
import _RUNNING_ICON from '../../public/images/icons/running.svg'
import _SHARE_ICON from '../../public/images/icons/share.svg'
import _SPOT_ICON from '../../public/images/icons/spot.svg'
import _TOOLTIP_ICON from '../../public/images/icons/tooltip.svg'
import _WHATSAPP_ICON from '../../public/images/icons/whatsapp.svg'

export const APP_STORE_ICON = _APP_STORE_ICON
export const APP_STORE_SMALL_ICON = _APP_STORE_SMALL_ICON
export const ARROW_LEFT_ICON = _ARROW_LEFT_ICON
export const ARROW_RIGHT_ICON = _ARROW_RIGHT_ICON
export const ARROW_RIGHT_WHITE_ICON = _ARROW_RIGHT_WHITE_ICON
export const ARROW_DOWN_ICON = _ARROW_DOWN_ICON
export const ARROW_UP_ICON = _ARROW_UP_ICON
export const ARROW_UP_RIGHT_ICON = _ARROW_UP_RIGHT_ICON
export const CALENDAR_ICON = _CALENDAR_ICON
export const CHECK_ICON = _CHECK_ICON
export const CHECK_WHITE_ICON = _CHECK_WHITE_ICON
export const CHEVRON_RIGHT_ICON = _CHEVRON_RIGHT_ICON
export const CLOCK_ICON = _CLOCK_ICON
export const CLOCK_WHITE_ICON = _CLOCK_WHITE_ICON
export const CLOSE_ICON = _CLOSE_ICON
export const COPY_ICON = _COPY_ICON
export const DOT_ICON = _DOT_ICON
export const EMAIL_ICON = _EMAIL_ICON
export const EVERSPORTS_LOGO = _EVERSPORTS_LOGO
export const FAVICON = _FAVICON
export const INFO_ICON = _INFO_ICON
export const INTERNATIONAL_ICON = _INTERNATIONAL_ICON
export const KEY_ICON = _KEY_ICON
export const LEVEL_ICON = _LEVEL_ICON
export const LINK_ICON = _LINK_ICON
export const LOCATION_ICON = _LOCATION_ICON
export const LOG_OUT_ICON = _LOG_OUT_ICON
export const MESSAGE_ICON = _MESSAGE_ICON
export const MY_BOOKINGS_ICON = _MY_BOOKINGS_ICON
export const MY_PRODUCTS_ICON = _MY_PRODUCTS_ICON
export const MY_DETAILS_ICON = _MY_DETAILS_ICON
export const MY_VIDEOS_ICON = _MY_VIDEOS_ICON
export const MENU_ICON = _MENU_ICON
export const PEOPLE_ICON = _PEOPLE_ICON
export const PLAY_STORE_SMALL_ICON = _PLAY_STORE_SMALL_ICON
export const PLAY_STORE_ICON = _PLAY_STORE_ICON
export const ROOM_ICON = _ROOM_ICON
export const RUNNING_ICON = _RUNNING_ICON
export const SHARE_ICON = _SHARE_ICON
export const SPOT_ICON = _SPOT_ICON
export const WHATSAPP_ICON = _WHATSAPP_ICON
export const TOOLTIP_ICON = _TOOLTIP_ICON
